import {Divider, Menu} from "antd";
import React, { useEffect } from 'react';
import { getResources, ReduxState, ResourceDefinition } from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from "react-router-dom";
import { setViewMode } from "../../actions/uiActions";
import {
  faChartPie
} from '@fortawesome/free-solid-svg-icons';
import FaIcon from "../Icons/FaIcon";
import { inNav, usePov } from "../Common/pov";
import './SideNav.css';

const getViewModeOfResource = (currentResource: string, resources: ResourceDefinition[]) => {
  for (let resource of resources) {
    if (resource.name == currentResource) {
      return resource.options?.viewMode
    }
  }
  return null;
}

const renderResource = (resource: any) => {
  return (
    <Menu.Item key={resource.name}>
      <NavLink to={"/" + resource.name}>
        <span
          className="icon"
        >
          {resource.icon}
        </span>
        <span className="label" style={{ textTransform: 'capitalize' }}>{resource.options?.label || resource.name}</span>
      </NavLink>
    </Menu.Item>
  )
}
const SideNav = () => {
  const resources = useSelector(getResources);
  const dispatch = useDispatch();
  const pov = usePov();
  const currentPath = useSelector((state: ReduxState) => state.router.location.pathname);
  const user = JSON.parse(localStorage.getItem('user') as string);

  useEffect(() => {
    // a page that belongs to another view — reached from a link, the search
    // bar, a notification — brings that view with it, Admin included
    const currentResource: string = currentPath.replace(/[\/\\]/, '').split('/')[0];
    const resourceViewMode = getViewModeOfResource(currentResource, resources)
    if (resourceViewMode && resourceViewMode != pov && !(resourceViewMode === "SUPERUSER")) {
      // stored as well, as the top bar's switch does: the stored preference
      // is what usePov reads first, so the store alone would not move it
      localStorage.setItem('pov_preference', resourceViewMode);
      dispatch(setViewMode(resourceViewMode));
    }
  }, [currentPath, pov])

  return (
    <nav className="nav-rail" aria-label="Main">
      <div className="nav-rail__scroll">
        {/* Not selectable: which item is current comes from the router, through
            NavLink's own `active` class. Left to itself antd would also mark
            whatever was last clicked, and the two would disagree the moment a
            page navigated on its own. */}
        <Menu theme="light" mode="inline" selectable={false}>
          <Menu.Item key='dashboard'>
            <NavLink exact to='/'>
              <span className="icon">{FaIcon(faChartPie)}</span>
              <span className="label" style={{ textTransform: 'capitalize' }}>Dashboard</span>
            </NavLink>
          </Menu.Item>
          {
            resources.map(resource =>
              !resource.options?.belowFold && inNav(resource.options?.viewMode, pov)
                ? renderResource(resource)
                : null
            )
          }
          <Divider />
          {
            resources.map(resource =>
              resource.options?.belowFold == true && inNav(resource.options?.viewMode, pov)
                ? renderResource(resource)
                : null
            )
          }
          {
            user?.is_superuser &&
              <>
                <Divider />
                {resources.map((resource => resource.options?.viewMode==="SUPERUSER"?renderResource(resource):null))}
              </>
          }
        </Menu>
      </div>
    </nav>
  )
}

export default SideNav;